import { Component } from 'react';
import { connect } from 'react-redux';
import {
  Emails,
  FormGroup,
  RadioGroup,
  Usernames
} from 'components/common/form';

const UsersCreateMultiple = connect((state) => ({
  language: state.language,
  messages: state.messages,
  serverConfig: state.serverConfig
}))(
  class extends Component {
    state = { userSelector: 'useEmail' };

    handleModalVisible = () => {
      this.usernameContainer?.querySelector('input').focus();
      this.emailContainer?.querySelector('input').focus();
    };

    handleUserSelectorChange = (value) => {
      this.props.onUserSelectorChange(value);
      this.setState({ userSelector: value });
    };

    render() {
      const {
        messages,
        onValueChange,
        serverConfig: { accountEnableUsernameAccounts }
      } = this.props;

      const { userSelector } = this.state;

      return (
        <>
          {accountEnableUsernameAccounts ? (
            <FormGroup>
              <RadioGroup
                field="userSelector"
                initialValue={userSelector}
                inline={true}
                onChange={this.handleUserSelectorChange}
                options={[
                  {
                    id: 'useEmail',
                    value: 'useEmail',
                    label: messages.userCreateWithEmail
                  },
                  {
                    id: 'useUsername',
                    value: 'useUsername',
                    label: messages.userCreateWithoutEmail
                  }
                ]}
              />
            </FormGroup>
          ) : null}

          <FormGroup
            label={
              userSelector === 'useEmail'
                ? messages.emailAddresses
                : messages.commonUsernames
            }
            labelTooltip={messages.emailAddressesTooltip}
            maxWidth="100%"
          >
            {!accountEnableUsernameAccounts || userSelector === 'useEmail' ? (
              <Emails
                disableOptions={true}
                field="emails"
                id="emails"
                onUserChange={onValueChange}
              />
            ) : null}

            {accountEnableUsernameAccounts && userSelector === 'useUsername' ? (
              <Usernames
                disableOptions={true}
                field="usernames"
                id="usernames"
                onUserChange={onValueChange}
              />
            ) : null}
          </FormGroup>
        </>
      );
    }
  }
);

export default UsersCreateMultiple;
